/* Core & libraries */
import * as React from 'react';
import { useTheme } from 'react-jss';

/* Helpers, constants, custom methods, internal libraries */
import { useLocaleContext } from '../../../contexts/localeContext.js';

/* Components */

/* Styles */
import styles from './styles.js';
import { FormattedMessage } from 'react-intl';
import { ReactComponent as BackIcon } from '../../../resources/images/flip-backward.svg';
import UCButton from '../../buttons';
import { ADMIN_COMPANY_DETAILS_ROUTE } from '../../../constants/routes';
import { useNavigate } from 'react-router';
import {
  useUserContext,
  useUserUpdateContext,
} from '../../../contexts/userContext';
import { ACCEPTED_LANGUAGES } from '../../../constants/appConstants';

const ManagedCompanyBar = () => {
  const theme = useTheme();
  const classes = styles({ theme });

  const navigate = useNavigate();
  const localeContext = useLocaleContext();
  const setUserContext = useUserUpdateContext();
  const userContext = useUserContext();

  const handleManageCompanies = async () => {
    await setUserContext({
      ...userContext,
      userInfo: {
        ...userContext.userInfo,
        language: ACCEPTED_LANGUAGES[localeContext],
        locale: localeContext,
        companyInfo: null,
      },
      manageCompany: false,
    });
    navigate(`${ADMIN_COMPANY_DETAILS_ROUTE.replace(":companyEntityId", userContext?.userInfo?.companyInfo?.companyEntityId)}`);  
  };

  return (
    userContext?.manageCompany && (
      <div className={classes.managedCompanyWrapper}>
        <div className={classes.managedCompanyBar}>
          <UCButton
            type="deleteLink"
            className={classes.manageButton}
            text={<FormattedMessage id='admin.managedCompany.button' />}
            icon={<BackIcon />}
            onClick={handleManageCompanies}
          />
          <p><FormattedMessage id='admin.managedCompany.view' /> "{userContext?.userInfo?.companyInfo?.companyName}"</p>
        </div>
      </div>
    )
  );
};

export default ManagedCompanyBar;
